import { render, staticRenderFns } from "./ProgramacaoCliente.vue?vue&type=template&id=98624632"
import script from "./ProgramacaoCliente.vue?vue&type=script&lang=js"
export * from "./ProgramacaoCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports